(function() {
    'use strict';

    angular
        .module('app')
        .directive('uploadDirective', uploadDirective);

    uploadDirective.$inject = ['$window', 'FileUploader', 'loginService']; //, '$scope'];
    
    function uploadDirective($window, FileUploader, loginService) { //, $scope) {
        // Usage:
        //     <uploadDirective></uploadDirective>
        // Creates:
        // 

        var directive = {
            link: link,
            restrict: 'EA',
            templateUrl: 'app/checkin/templates/uploadDirective.html',
            controller: 'uploadController',
            controllerAs: 'vm'
        };

        return directive;

        function link(scope, element, attrs) {
            console.info('uploadDirective link fired.');
        }
    }

})();